<div class="h-full flex flex-col justify-between">
    @if (!fieldInterventionEntity()) {
        <app-loading
            class="m-auto"
            size="30" />
    } @else {
        <div class="panel-content">
            <span class="font-normal text-2xl">
                <app-title
                    [title]="fieldInterventionEntity()!.dataAttributes['businessIdentifier']"
                    (goToPreviousPage)="
                        fieldInterventionFormsRegexp.test(router.url)
                            ? answersActionButtonConfig().action()
                            : fieldInterventionService.toggleFieldInterventionEntityDetailPanel(
                                  fieldInterventionEntity()!.id!
                              )
                    " />
            </span>

            <div class="panel-information flex flex-row justify-between flex-wrap gap-x-10 gap-y-5 my-8">
                <div class="flex flex-col">
                    <p class="!m-0 !mb-1 text-caption text-on-surface font-normal">{{ 'createdAt' | transloco }}</p>
                    <p class="!m-0">
                        {{ (fieldInterventionEntity()!.createdAt | date: translateService.localDate()) ?? '-' }}
                    </p>
                </div>
                <div class="flex flex-col">
                    <p class="!m-0 !mb-1 text-caption text-on-surface font-normal">{{ 'status' | transloco }}</p>
                    <p class="!m-0">{{ fieldInterventionEntity()!.status | transloco }}</p>
                </div>
                @for (list of [formItemsWithState(), peopleItemsWithState()]; track $index) {
                    <div class="flex flex-col gap-2">
                        <app-field-intervention-entity-items-list
                            [entity]="fieldInterventionEntity()!"
                            [items]="list"
                            [title]="['form', 'operator'][$index]" />
                    </div>
                }
            </div>

            @if (favoriteDataAttributes() || dataAttributes()) {
                <span class="font-medium">
                    <fa-icon
                        class="mr-1 title-icon text-secondary"
                        [icon]="['fas', 'star']" />
                    {{ 'favoriteAttributes' | transloco }}
                </span>

                <div
                    class="panel-information flex flex-row justify-between flex-wrap gap-x-10 gap-y-5 mt-8 mb-4"
                    [class.mb-8]="showAll().dataAttributes">
                    @for (key of Object.keys(favoriteDataAttributes()!); track key) {
                        <div class="flex flex-col">
                            <p class="!m-0 !mb-1 text-caption text-on-surface font-normal">{{ key }}</p>
                            <p class="!m-0">{{ favoriteDataAttributes()![key] ?? '-' }}</p>
                        </div>
                    }
                </div>

                @if (showAll().dataAttributes) {
                    <p class="!m-0 font-medium">
                        {{ 'attribute' | transloco }}
                    </p>

                    <div class="panel-information flex flex-row justify-between flex-wrap gap-x-10 gap-y-5 mt-8 mb-4">
                        @for (key of Object.keys(dataAttributes()!); track key) {
                            <div class="flex flex-col">
                                <p class="!m-0 !mb-1 text-caption text-on-surface font-normal">{{ key }}</p>
                                <p class="!m-0">{{ dataAttributes()![key] ?? '-' }}</p>
                            </div>
                        }
                    </div>
                }

                @if (dataAttributes() && Object.keys(dataAttributes()!).length) {
                    <span
                        class="text-outline text-xs cursor-pointer hover:underline"
                        (click)="toggleList('dataAttributes')">
                        {{ (showAll().dataAttributes ? 'displayLess' : 'displayMore') | transloco }}
                        {{ showAll().dataAttributes ? '' : `(${Object.keys(dataAttributes()!).length})` }}
                        <fa-icon
                            [icon]="['fas', 'chevron-down']"
                            [rotate]="showAll().dataAttributes ? 180 : undefined" />
                    </span>
                }
            }
        </div>
    }
    <div class="footer">
        @if (isFieldInterventionStatusToPlan()) {
            <app-button
                [disabled]="!fieldInterventionPermissionService.canManageFieldIntervention()"
                [icon]="['fas', 'trash']"
                [label]="'delete' | transloco"
                [tooltip]="
                    !fieldInterventionPermissionService.canManageFieldIntervention()
                        ? ('insufficientPermissions' | transloco)
                        : undefined
                "
                [type]="ButtonType.ALERT_SECONDARY"
                (onClick)="handleRemoveButton()" />

            <app-button
                [disabled]="!fieldInterventionPermissionService.canManageFieldIntervention()"
                [icon]="['far', 'timeline-arrow']"
                [label]="'plan' | transloco"
                [tooltip]="
                    !fieldInterventionPermissionService.canManageFieldIntervention()
                        ? ('insufficientPermissions' | transloco)
                        : undefined
                "
                [type]="ButtonType.PRIMARY"
                (onClick)="openPlanningModal()" />
        } @else {
            <app-button
                [disabled]="!fieldInterventionPermissionService.canManageFieldIntervention()"
                [icon]="answersActionButtonConfig().icon"
                [label]="answersActionButtonConfig().label | transloco"
                [tooltip]="
                    !fieldInterventionPermissionService.canManageFieldIntervention()
                        ? ('insufficientPermissions' | transloco)
                        : undefined
                "
                [type]="ButtonType.PRIMARY"
                (onClick)="answersActionButtonConfig().action()" />
        }
    </div>
</div>
